<script setup lang="ts">
import SignalsList from "@/components/search/SignalsList.vue";
import DropdownMenu from "@/components/ui/DropdownMenu/DropdownMenu.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import InfoMarker from "@/components/ui/InfoMarker/InfoMarker.vue";
import { useSearchMenuStore } from "@/store/search/searchMenu";
import { fetchSignals } from "@/store/search/signalSync";
import { useSignalStore } from "@/store/search/signals";

const signalStore = useSignalStore();
</script>

<template>
  <DropdownMenu width="lg" :offset="{ top: 14 }" @open="fetchSignals()">
    <template #trigger="{ isOpen }">
      <span class="signals-trigger">
        <IconButton
          id="signals-menu-trigger"
          icon="filled/flash"
          data-dropdown-trigger
          data-no-screenshot
          highlight="signals"
          :text="$t('signals.title')"
          :activated="isOpen"
          :aria-expanded="isOpen"
          aria-haspopup="listbox"
          aria-controls="signals-dropdown"
        />
        <InfoMarker v-if="signalStore.selectedItems.length" :top="4" :right="4" />
      </span>
    </template>
    <SignalsList
      id="signals-dropdown"
      source="top_menu"
      @added="useSearchMenuStore().expandSearch()"
    />
  </DropdownMenu>
</template>

<style lang="scss" scoped>
.signals-trigger {
  position: relative;
  display: inline-flex;
}
</style>

<style lang="scss">
@use "@/styles/mixins/shadow";
@use "@/styles/variables/colors";

#signals-menu-trigger {
  position: relative;

  // the bolt keeps the link default colour in every button state, like the risky links icon
  .icon {
    color: colors.$palette-brand-70;
  }
}

// New-feature highlight: gold dot top-right and a gold ring.
#signals-menu-trigger.feature-highlighted:not(.activated) {
  @include shadow.feature-highlight;

  &::after {
    content: "";
    position: absolute;
    top: 3px;
    right: 3px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: colors.$alternative-yellow;
  }
}
</style>
